import React,{ Component } from "react";
import './index.less'
//import banner from '../image/banner.jpg'
import News from  '../compoonents/news/index'
import News2 from  '../compoonents/news2/index'
import Video from  '../compoonents/video/index'
import Banner from  '../compoonents/banner/index'
import LongBanner from  '../compoonents/longBanner/index'
import ScrollSpan from  '../compoonents/scrollSpan/index'
import Axios from "../../../components/request/axios";
import {message, Modal} from "antd";
import httpName from "../../../components/httpName";
import GetUrlParam from "../../../components/getUrlParam";
class PC extends Component {
    state={
        bigImg:[],
        ddjs:[]
    };
    componentDidMount() {
        let _this=this;
        Axios.get('/api/v1/news/',{channel__name:'党的精神'}).then((res)=>{
            if(res){
                let news=res.results;
                _this.setState({
                    ddjs:news,
                });
            }
        });
        Axios.get('/api/v1/news/',{channel__name:'首页大图'}).then((res)=>{
            if(res){
                let news=res.results;
                _this.setState({
                    bigImg:news,
            });
            }
        });
    }
    toShowNews=(id)=>{
        window.location.hash='#/news/newshow?id='+id+'&ddjs=1';
        //window.open('#/news/newshow?id='+id,'_blank');
    };
    handleOk=()=>{
        let id=this.state.id;///获取当前新闻文章或者教育文章的id
        let integral_price=this.state.integral_price;///所需积分数
        let title=this.state.title;///购买的文章的标题
        let key=this.state.key;///channel的id
        let data={
            is_show:true,
            related_id:id,//权益id （文章id，教程id）
            related_type:'教程',//权益类型（是普通文章还是教程）
            action_name:'购买继续教育',//权益类型（是普通文章还是教程）
            integral_change:'-'+integral_price,// 消费积分的事件名（比如购买教程，阅读文章，是你前端传递的可以自定义，为了展示消费记录用的）
            details:title,// 消费权益的描述 （比如 某个教程的标题）
            transaction_status:1,// 购买状态 0：兑换失败 1：兑换成功  2：无兑换记录
        };
        if(window.localStorage.getItem('userInfo')){
            data.creator=httpName+'/users/'+JSON.parse(window.localStorage.getItem('userInfo')).id+'/';
            data.editor=httpName+'/users/'+JSON.parse(window.localStorage.getItem('userInfo')).id+'/';
        }
        Axios.post('/api/v1/integral_exchange/',data).then((res)=>{
            if(res){
                message.success('兑换成功!');
                setTimeout(()=>{
                    window.location.hash='#/news/newshow?id='+id+"&key="+key+'&st=1'
                },100);
            }
        })
    };
    handleCancel=()=>{
        this.setState({
            isModalVisible:false
        })
    };
    openModel = (id,integral_price,title,key) =>{
        this.setState({
            isModalVisible:true,
            id,
            integral_price,
            title,
            key
        })
    };
    render() {
        let {bigImg,ddjs,isModalVisible,integral_price}=this.state;
        return (
            <div className='index_pc'>
                <div style={{width:'100%',padding:' 0 10px',background:'#f1f1f1'}}>
                    <ScrollSpan />
                </div>
                {bigImg.length>0&&bigImg[0].big_image?
                    <img  src={bigImg[0].big_image.file} alt='banner' style={{width:'100%'}} />:''
                }
                <div className='contents clear'>
                    <div style={{width:'48%',float:'left'}}>
                        <Banner  />
                    </div>
                    <div style={{width:'48%',float:'right'}}>
                        <News length={8} list={[
                            <span><span className='iconfont icondongtai' /> 会议报道</span>,
                            <span><span className='iconfont icontongzhi3' /> 活动通知</span>
                        ]} />
                    </div>
                </div>
                <LongBanner />
                <div style={{background:'#f6fafb',width:'100%',paddingBottom:'20px'}}>
                    <div className='contents clear' >
                        <div style={{width:'30%',float:'left',marginRight:"4.5%"}}>
                            <News length={11} list={[<span><span className='iconfont iconxiezuo' />地方协作组</span>]} />
                        </div>
                        <div style={{width:'30%',float:'left',marginRight:"4.5%"}}>
                            <News length={11} list={[<span><span className='iconfont iconyisheng' /> 专家门诊时间</span>]} />
                        </div>
                        <div style={{width:'30%',float:'left'}}>
                            <News2 list={[<span><span className='iconfont iconzhinan' /> 指南/文献</span>,
                            <span><span className='iconfont iconzazhi' /> 期刊杂志</span>]} />
                        </div>
                    </div>
                </div>
                {ddjs.length>0&&ddjs[0].image?
                    <img  src={ddjs[0].image.file} alt='banner' style={{width:'100%',cursor:'pointer'}} onClick={()=>this.toShowNews(ddjs[0].id)} />:''
                }
                <div className='contents'>
                    <Video openModel ={this.openModel} />
                </div>
                <Modal title="积分兑换" visible={isModalVisible} onOk={this.handleOk} onCancel={this.handleCancel}>
                    <p>此文章"{this.state.title}"需要{integral_price}积分兑奖，是否兑换?</p>
                </Modal>
            </div>
        );
    }
}
export default PC